import axiosFactory from "./axios.factory";
import BaseService from "./base.service";

/**
 * File Service
 * @class FileService
 * @extends BaseService
 */
class OrdersService extends BaseService {
  async getPickTypeRules(params) {
    return axiosFactory()
      .get(`${this.entity}/picktype_import_rules`, { params })
      .then((res) => {
        if (!res.data?.data?.length) {
          return {
            items: [],
            totalItems: 0,
          };
        }
        const items = res.data.data.map((element) => {
          let skus = [];
          Object.keys(element).forEach((key) => {
            if (key.includes("sku") && element[key]) {
              const qKey = `q${this.toTitleCase(key)}`;
              skus.push({ sku: element[key], quantity: element[qKey] ? element[qKey] : 1 });
            }
          });
          return {
            id: element.id,
            ruleVersion: element.ruleVersion,
            creationDate: element.creationDate,
            skus: skus,
          };
        });
        return {
          items,
          totalItems: res.data?.total,
          pageIndex: res.data?.pageIndex,
          pageSize: res.data?.pageSize,
        };
      });
  }
  generateSKUList(skus) {
    let skuList = {};
    skus.forEach((sku, index) => {
      skuList[`sku${index + 1}`] = sku.sku;
      skuList[`qSku${index + 1}`] = parseInt(sku.quantity, 10) || 1;
    });
    return skuList;
  }
  async createRule(data) {
    const formData = { ruleVersion: data.ruleVersion, ...this.generateSKUList(data.skus) };
    return axiosFactory()
      .post(`${this.entity}/picktype_import_rules`, formData)
      .then((res) => {
        return res.data;
      });
  }
  async updateRule(data) {
    const formData = { ruleVersion: data.ruleVersion, ...this.generateSKUList(data.skus) };
    return axiosFactory()
      .put(`${this.entity}/picktype_import_rules/${data?.id}`, formData)
      .then((res) => {
        return res.data;
      });
  }
  async deleteRule(id) {
    return axiosFactory()
      .delete(`${this.entity}/picktype_import_rules/${id}`)
      .then((res) => {
        return res.data;
      });
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
  }

  // --- Reklamationsbilder je Rechnungsnummer (Trello 21.08.) ---

  async images(invoiceNumber) {
    const res = await axiosFactory().get(`/orders/images/${encodeURIComponent(invoiceNumber)}`);
    return res.data.data || [];
  }

  imageContentUrl(invoiceNumber, imageId) {
    return axiosFactory()
      .get(`/orders/images/${encodeURIComponent(invoiceNumber)}/${imageId}/content`, { responseType: "blob" })
      .then((res) => URL.createObjectURL(new Blob([res.data])));
  }

  async uploadImage(invoiceNumber, file) {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axiosFactory().post(`/orders/images/${encodeURIComponent(invoiceNumber)}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 60000,
    });
    return res.data.data;
  }

  async deleteImage(invoiceNumber, imageId) {
    const res = await axiosFactory().delete(`/orders/images/${encodeURIComponent(invoiceNumber)}/${imageId}`);
    return res.data;
  }
}

export default new OrdersService("orders");
